import TransactionType from "./TransactionType";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import * as pricingActions from "store/actions/pricing/pricingActions";
import * as pricingSelectors from "store/selectors/pricing/pricingSelectors";

/**
 * Layer-level Transaction. Displays the resolved value, which falls back to
 * the program-level transaction when the layer has none of its own
 * (see domain/layerResolvers.js), and writes only to the layer.
 */
const LayerTransaction = ({ disabled }) => {
  const dispatch = useDispatch();
  const layer = useSelector(pricingSelectors.selectResolvedActiveLayer);

  return (
    <Grid item xs={12}>
      <TransactionType
        value={layer?.transaction ?? null}
        disabled={disabled}
        onChange={(transaction) => {
          if (transaction !== layer?.transaction) {
            dispatch(
              pricingActions.updateLayer({
                layerId: layer.id,
                values: { transaction },
              })
            );
          }
        }}
      />
    </Grid>
  );
};

export default LayerTransaction;
